import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import { styled, alpha } from '@mui/material/styles';
import { Box, Link, Typography } from '@mui/material';
// auth
import { useAuthContext } from '../../../auth/useAuthContext';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components
import { CustomAvatar } from '../../../components/custom-avatar';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: alpha(theme.palette.grey[500], 0.12),
  cursor: 'pointer'
}));

// ----------------------------------------------------------------------

export default function NavAccount() {
  const navigate = useNavigate()
  const authState = useSelector((state: RootState) => state.auth);

  return (
      <StyledRoot onClick={() => {navigate(PATH_DASHBOARD.user.profile)}}>
        <CustomAvatar src={authState.userReturn?.picture} alt={authState.userReturn?.name} name={authState.userReturn?.name} />

        <Box sx={{ ml: 2, minWidth: 0 }}>
          <Typography variant="subtitle2" noWrap>
            {authState.userReturn?.name}
          </Typography>

          <Typography variant="body2" noWrap sx={{ color: 'text.secondary', fontSize: 10 }}>
            {authState.userReturn.email}
          </Typography>
        </Box>
      </StyledRoot>
  );
}
